import React from 'react';
import { StarButton } from '../StarButton';
import type { Project } from '../../types/project';

interface PageHeaderProps {
  title: string;
  icon?: string;
  project?: Project;
  helpUrl?: string;
  rightContent?: React.ReactNode;
}

export function PageHeader({ icon, title, project, helpUrl, rightContent }: PageHeaderProps) {
  const titleEl = (
    <h1 className={!rightContent && helpUrl ? 'pull-left' : undefined}>
      {project ? <StarButton project={project} /> : icon && <i className={icon} aria-hidden="true" />}
      {' '}{title}
    </h1>
  );

  if (rightContent) {
    return (
      <div className="page-header">
        <div className="row">
          <div className="col-sm-7">{titleEl}</div>
          <div className="col-sm-5 text-right">{rightContent}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={`page-header${helpUrl ? ' clearfix' : ''}`}>
      {titleEl}
      {helpUrl && (
        <a
          className="pull-left"
          style={{ marginLeft: 8, marginTop: 14, display: 'block' }}
          href={helpUrl}
          target="_blank"
          rel="noreferrer"
          title="Get Help"
        >
          <i className="far fa-question-circle fa-lg" aria-hidden="true" />
        </a>
      )}
    </div>
  );
}
